import {Component, computed, inject, input} from '@angular/core';
import {FormControl} from '@angular/forms';
import {TranslatePipe} from '@ngx-translate/core';
import {Dropdown} from '../../../../components/dropdown/dropdown';
import {FeatureStore} from '../../services/feature-store';
import {FeatureSelect} from '../../../../../api/models';

@Component({
  selector: 'elcia-feature-dropdown',
  imports: [Dropdown, TranslatePipe],
  templateUrl: './feature-dropdown.html',
})
export class FeatureDropdown {
  private readonly featureStore = inject(FeatureStore);
  protected readonly features = computed<FeatureSelect[]>(() => this.featureStore.features());
  control = input.required<FormControl>();
}
